import Div from "@jumbo/shared/Div";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { Button, Typography } from "@mui/material";
import FormTextField from "app/components/InputField/FormTextField";
import { updateUnit } from "app/services/apis/updateUnit";
import Swal from "sweetalert2";
import { addUnit } from "app/services/apis/addUnit";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { addGst } from "app/services/apis/addGst";
import { updateGst } from "app/services/apis/updateGst";

export default function AddGst() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { state } = useLocation();
  const [isSubmitting, setSubmitting] = useState(false);
  const gst = {
    gst_value: state?.gst_value ? state?.gst_value : "",
  };
  const validationSchema = yup.object({
    gst_value: yup
      .string("Enter GST Percentage")
      .required("Gst Percentage is required"),
  });
  const onUserSave = async (values) => {
    // console.log({ ...values });
    setSubmitting(true);
    if (pathname == "/master/gst/edit") {
      const data = await updateGst(values, state.id);
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Gst Edited Successfully",
          text: "",
        });
        navigate("/dashboard/master/gst");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.message,
          text: "",
        });
      }
    } else {
      const data = await addGst(values);
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "GST Added Successfully",
          text: "",
        });
        navigate("/dashboard/master/gst");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.data?.message,
          text: "",
        });
      }
    }
    setSubmitting(false);
  };
  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">
        {pathname == "/master/gst/add" ? "Add New GST %" : "Edit GST %"}
      </Typography>
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={gst}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onUserSave}
        >
          {({ values }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Div
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    columnGap: 5,
                  }}
                >
                  <FormTextField name="gst_value" label="GST Percentage" />
                </Div>
                <Div
                  sx={{
                    width: "93.5%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                    mt: 3,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure you want to cancel?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          navigate("/dashboard/master/gst");
                        }
                      });
                    }}
                  >
                    Cancel
                  </Button>

                  <LoadingButton
                    variant="contained"
                    type="submit"
                    sx={{ width: "100px" }}
                    loading={isSubmitting}
                  >
                    Save
                  </LoadingButton>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
